<template>
  <div class="card-info p-4">
    <div class="row">
      <div class="col-11 col-md-6 col-lg-5 col-xl-3 mx-auto mt-5">
        <card>
          <div class="text-center mt-3 mb-4">
            <img round width="120" src="@/assets/img/logo.png" alt="AVTECH EDU" />
          </div>
          <h3 class="text-center">{{states[state].title}}</h3>
          <component :is="state" v-model="state" />
          <hr />
          <br />
          <template v-for="(s,k) in states">
            <div :key="k" v-if="k!==state">
              <p-button class="w-100 mb-3" type="info" round @click.native.prevent="state=k">
                {{s.key | setText(s.title)}}</p-button>
            </div>
          </template>


          <h5 @click="$modal.show('policy')" class="text-center mt-4 link">{{$store.state.text['policy']}} Политика конфиденциальности</h5>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
export default {
  name: "auth",
  components: {
    "login": () => import("@/components/Auth/Login"),
    "register": () => import("@/components/Auth/Register"),
    "restore": () => import("@/components/Auth/Restore"),
  },
  mounted() { },
  data() {
    return {
      state: 'login',
      states: {
        login: {
          key: 'login',
          title: 'Вход в систему'
        },
        restore: {
          key: 'restore',
          title: 'Восстановление'
        },
        register: {
          key: 'register',
          title: 'Регистрация'
        },
      }
    };
  },
  methods: {

  },
};
</script>
<style>

</style>
